import clsx from 'clsx';
import urlBuilder from '@sanity/image-url';
import {SanityPageType} from '~/types/sanityTypes';
import {useSanityClient} from '~/lib/utils';
import useSanityData from '~/lib/useSanityData';

export function DefaultPageHeader({
  page: serverPage,
  sanityQuery,
  sanityParams,
  className,
}: {
  page: SanityPageType;
  sanityQuery: string;
  sanityParams: {slug: string};
  className?: string;
}) {
  const styles = clsx('relative flex flex-col bg-bgDark', className);

  const page: SanityPageType = useSanityData(
    serverPage,
    sanityQuery,
    sanityParams,
  );

  if (page.hero && page.hero.title) {
    return (
      <div className={styles}>
        {page.hero.backgroundImage && (
          <img
            src={urlBuilder(useSanityClient)
              .image(page.hero.backgroundImage)
              .auto('format')
              .url()}
            alt={page.hero.backgroundImage.altText || ' '}
            loading="lazy"
            style={{
              objectFit: 'cover',
              width: '100%',
              height: '100%',
              position: 'absolute',
            }}
          />
        )}
        <div className="absolute h-full w-full opacity-20 bg-black z-10"></div>
        <div className="container z-20 relative text-white pt-[120px] pb-[40px]">
          {page.hero.optionalTitle && (
            <span className="text-4xl text-outline-white text-transparent font-clash uppercase break-words md:text-5xl md:leading-[0.7]">
              {page.hero.optionalTitle}
            </span>
          )}
          <h1 className="text-4xl break-words mb-0 md:text-5xl">
            {page.hero.title}
          </h1>
          {page.hero.leadText && (
            <p className="mb-0 mt-4">{page.hero.leadText}</p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={styles}>
      <div className="container z-20 relative text-white pt-[120px]">
        <h1 className="text-4xl break-words md:text-5xl">{page.title}</h1>
      </div>
    </div>
  );
}
